import { Box, Button, Typography, useTheme } from '@mui/material';

import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

const FORM_CONTROL_HEIGHT = 45;
const BUTTON_WIDTH = 40;

const QuantityControl = ({
  counter,
  minValue,
  handleDecrement,
  label,
  maxValue,
  handleIncrement,
  roomInfo,
  total,
  totalLimit,
}) => {
  const theme = useTheme();

  const commonButtonStyles = {
    position: 'absolute',
    minWidth: BUTTON_WIDTH,
    maxWidth: BUTTON_WIDTH,
    height: FORM_CONTROL_HEIGHT,
    color: '#000',
    borderRadius: '8px',
    '&:hover': {
      color: theme.text1,
      backgroundColor: theme.primary,
    },
  };

  let isIncrementDisabled = counter >= maxValue;
  const reachedTotalLimit = totalLimit !== undefined && total >= totalLimit;

  if (reachedTotalLimit) {
    isIncrementDisabled = true;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: FORM_CONTROL_HEIGHT,
        backgroundColor: '#fff',
        borderRadius: '8px',
        border: `1px solid ${theme.tertiary}`,
        boxSizing: 'border-box',
        '&:hover': {
          borderColor: theme.primary,
        },
      }}
    >
      {/* Decrement */}
      <Button
        id={
          label === 'Adultos'
            ? `removeAdultButton${roomInfo?.n}`
            : `removeChildButton${roomInfo?.n}`
        }
        disabled={counter <= minValue}
        onClick={handleDecrement}
        sx={{
          ...commonButtonStyles,
          left: 0,
        }}
      >
        <RemoveIcon fontSize="small" />
      </Button>

      {/* Counter */}
      <Typography
        sx={{
          mx: `${BUTTON_WIDTH + 8}px`,
          minWidth: 40,
          textAlign: 'center',
          fontSize: 16,
          fontWeight: 400,
          color: '#000',
          lineHeight: 1,
        }}
      >
        {counter}
      </Typography>

      {/* Increment */}
      <Button
        id={
          label === 'Adultos'
            ? `addAdultButton${roomInfo?.n}`
            : `addChildButton${roomInfo?.n}`
        }
        disabled={isIncrementDisabled}
        onClick={handleIncrement}
        sx={{
          ...commonButtonStyles,
          right: 0,
        }}
      >
        <AddIcon fontSize="small" />
      </Button>
    </Box>
  );
};

export default QuantityControl;
